import React from 'react';
import './App.css';
import CompanyListing from './components/CompanyListing';
import { Provider } from './context/FilterContext';

function App() {

  return (
    <div className="App">
      {/*<small>You are running this application in <b>{process.env.NODE_ENV}</b> mode @ <b>{process.env.REACT_APP_DOMAIN}</b>.</small>*/}
      <Provider>
        <CompanyListing />
      </Provider>
    </div>
  );
}

export default App;
